export default "__VITE_ASSET__Vjqi1YYM__"